@if (isButtonDisplayed()) {
  @let buttonLabel = 'ada-chat.button.label' | translate;
  @let isTokenLoadingValue = isTokenLoading();

  <button
    cdkDrag
    cdkDragBoundary="html"
    type="button"
    class="ada-chat-button"
    animate.leave="ada-chat-button--leaving"
    tooltipPosition="left-center"
    [attr.aria-expanded]="isChatOpened()"
    [cdkDragFreeDragPosition]="dragPosition()"
    [kdsTooltip]="buttonLabel"
    [attr.aria-label]="buttonLabel"
    [disableTooltip]="isDragging()"
    [disabled]="isTokenLoadingValue"
    (cdkDragStarted)="handleDragStart()"
    (cdkDragEnded)="handleDragEnd($event)"
    (click)="openAdaChat()"
  >
    <div class="ada-chat-button__content">
      @if (isTokenLoadingValue) {
        <kds-spinner size="regular" />
      } @else {
        <svg
          class="ada-chat-button__icon"
          width="33"
          height="28"
          viewBox="0 0 33 28"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M32.125 13C32.125 20.1875 24.9375 26 16.125 26C13.75 26 11.5625 25.625 9.56246 24.9375C8.87496 25.4375 7.62496 26.1875 6.18746 26.8125C4.68746 27.5 2.87496 28 1.12496 28C0.687456 28 0.312456 27.8125 0.187456 27.4375C-4.3869e-05 27.0625 0.124956 26.625 0.374956 26.3125C0.437456 26.3125 0.437456 26.25 0.499956 26.1875C0.562456 26.125 0.687456 26 0.812456 25.875C1.06246 25.5625 1.37496 25.0625 1.74996 24.5C2.37496 23.5 2.93746 22.125 3.06246 20.5625C1.18746 18.4375 0.124956 15.875 0.124956 13C0.124956 5.875 7.24996 0 16.125 0C24.9375 0 32.125 5.875 32.125 13Z"
            fill="currentColor"
          />
        </svg>
      }

      @if (hasUnreadMessages()) {
        <div
          class="ada-chat-button__notification"
          role="status"
          aria-live="polite"
          [attr.aria-label]="'ada-chat.notifications.label' | translate"
        ></div>
      }
    </div>
  </button>
}
